import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleHalfFill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCircleHalfFill"><Path fillRule="evenodd" clipRule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20V4ZM2 12C2 6.47715 6.47715 2 12 2C12.3748 2 12.7451 2.02066 13.1099 2.06098C18.1109 2.61382 22 6.85205 22 12C22 17.148 18.1109 21.3862 13.1099 21.939C12.7451 21.9793 12.3748 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleHalfFill;
